import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Title } from '@restworld/ui-ds';

import { workerCertificatesAtom } from '../../../../employer-job-listing.atoms';
import { StyledSeparator } from './worker-experience';
import { CertificationSectionItem } from './certification-section-item';
import { TabCardWrapper } from '../candidate-profile-section';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICertificationSectionProps {}

const CertificationSection: React.FunctionComponent<ICertificationSectionProps> = (props) => {
  const workerCertificates = useAtomValue(workerCertificatesAtom);
  const itemsCount = workerCertificates?.length || 0;
  const { t } = useTranslation('onboarding-page');
  return (
    <TabCardWrapper title={t('certificate')}>
      <div tw="flex flex-col items-start pt-4">
        {workerCertificates?.map((workerCertificate, index) => (
          <div tw="w-full" key={index} id={`certifications-${index}`}>
            <CertificationSectionItem key={index} {...{ workerCertificate, workerCertificateIndex: index }} />
            {index < itemsCount - 1 && <StyledSeparator />}
          </div>
        ))}
        {!workerCertificates?.length && (
          <Title fontWeight="normal" textColor="gray-500" variant="h6-large">
            {t('missing_info')}
          </Title>
        )}
      </div>
    </TabCardWrapper>
  );
};

export default CertificationSection;
